export default function arrayPath(list: string[], separator: string = '.'): string {
  if (!list ||  list.length === 0) {
    return '';
  }
  return list.join(separator);
}
